import React from 'react';

const reasons = [
  {
    title: 'Built by ninea.ai',
    desc: 'Developed by the AI-focused software company behind GLIDENINE, SMARTNINE, and Ofinoo — trusted across 50+ countries.',
  },
  {
    title: 'Enterprise-Grade Security',
    desc: 'End-to-end encryption, role-based access controls, and complete audit trails. Your data stays protected.',
  },
  {
    title: 'Scalable Architecture',
    desc: 'Microservices-based design handles anything from 10 to 10,000+ employees without breaking a sweat.',
  },
  {
    title: 'Lightning Fast Setup',
    desc: 'Go from sign-up to fully operational in under an hour. No consultants or lengthy onboarding required.',
  },
];

const metrics = [
  { label: 'Reduction in scheduling time', value: '60%' },
  { label: 'Decrease in shift conflicts', value: '85%' },
  { label: 'Improvement in staff satisfaction', value: '40%' },
  { label: 'ROI within first quarter', value: '3x' },
];

function WhyChoose() {
  return (
    <section className="section section-gray" id="why-9works">
      <div className="container">
        <div className="why-grid">
          <div className="why-content fade-in">
            <div className="section-badge">Why 9works</div>
            <h2 className="section-title" style={{ textAlign: 'left' }}>
              Trusted by Teams That Demand More
            </h2>
            <p className="section-subtitle" style={{ textAlign: 'left' }}>
              9works isn't just another scheduling tool — it's a complete workforce
              operating system built for the modern workplace.
            </p>
            <div className="why-list">
              {reasons.map((r, i) => (
                <div className="why-item" key={i}>
                  <div className="why-check">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  </div>
                  <div>
                    <div className="why-item-title">{r.title}</div>
                    <div className="why-item-desc">{r.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="why-visual fade-in fade-in-delay-2">
            <div className="why-visual-card">
              <div style={{ fontSize: '13px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '24px', fontWeight: 600 }}>
                Impact Metrics
              </div>
              {metrics.map((m, i) => (
                <div className="why-visual-metric" key={i}>
                  <span className="why-visual-metric-label">{m.label}</span>
                  <span className="why-visual-metric-value">{m.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChoose;
